import { Box } from '@apia/theme';
import React from 'react';
import { TApiaFilter, TApiaFilterValue } from '../../types';
import Input from './Input';
import { useAppSelector } from '../../hooks/hooks';
import { getCurrentListId } from '../apia/common/lists/hooks/useCurrentListId';
import store from '../../store';
import { listActions } from '../../store/listSlice';

const InputTriple = ({
  filter,
  // ref,
  handleBlur,
  onPressEnter,
  handleClick,
  shouldShowRedBorderOnRequired,
}: {
  filter: TApiaFilter;
  // ref: React.Ref<HTMLInputElement | HTMLSelectElement>;
  shouldShowRedBorderOnRequired?: boolean;
  handleBlur: (
    ev:
      | React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
      | React.KeyboardEvent,
  ) => void;
  onPressEnter: ((ev: TApiaFilterValue) => void) | undefined;
  handleClick: (ev: React.MouseEvent) => void;
}) => {
  const fieldId = getCurrentListId();
  const reduxFilters =
    useAppSelector((global) => {
      return global.listSlice.lists[fieldId]?.filters?.filter((current) => {
        return (
          current.type === 'triple' &&
          filter.id === current.groupedInputFirstId &&
          current.id !== current.groupedInputFirstId
        );
      });
    }) ?? [];

  return (
    <>
      <Box sx={{ mr: '5px' }}>
        <Input
          aria-readonly={filter.readonly}
          readOnly={filter.readonly}
          value={filter.currentValue}
          type="text"
          placeholder={filter.placeholder}
          onChange={(ev) => {
            void store.dispatch(
              listActions.setFilters({
                listId: fieldId,
                filters: [
                  {
                    ...filter,
                    currentValue: ev.target.value,
                  },
                ],
                onlyRedux: true,
              }),
            );
          }}
          onBlur={handleBlur}
          onKeyDown={(ev) => {
            if (ev.key.toLowerCase() === 'enter') {
              handleBlur(ev);
              if (onPressEnter)
                onPressEnter((ev.target as HTMLInputElement).value);
            }
          }}
          onClick={handleClick}
          {...window.getVariant('input')}
          className={`filter ${
            shouldShowRedBorderOnRequired !== false &&
            (filter.error || filter.required)
              ? 'requiredFilter__Border'
              : ''
          }`}
          title={filter.title ?? filter.toolTip ?? String(filter.id)}
          // ref={ref as ForwardedRef<HTMLInputElement>}
          aria-label={filter.title ?? filter.toolTip ?? String(filter.id)}
          name={filter.id as string}
          id={filter.id as string}
        />{' '}
      </Box>

      <Box sx={{ mr: '5px' }}>
        <Input
          aria-readonly={reduxFilters[0].readonly}
          readOnly={reduxFilters[0].readonly}
          value={reduxFilters[0].currentValue}
          type="text"
          placeholder={reduxFilters[0].placeholder}
          onChange={(ev) => {
            void store.dispatch(
              listActions.setFilters({
                listId: fieldId,
                filters: [
                  {
                    ...reduxFilters[0],
                    currentValue: ev.target.value,
                  },
                ],
                onlyRedux: true,
              }),
            );
          }}
          onBlur={handleBlur}
          onKeyDown={(ev) => {
            if (ev.key.toLowerCase() === 'enter') {
              handleBlur(ev);
              if (onPressEnter)
                onPressEnter((ev.target as HTMLInputElement).value);
            }
          }}
          onClick={handleClick}
          {...window.getVariant('input')}
          className={`filter ${
            reduxFilters[0].error ? 'requiredFilter__Border' : ''
          }`}
          title={
            reduxFilters[0].title ??
            reduxFilters[0].toolTip ??
            String(reduxFilters[0].id)
          }
          aria-label={
            reduxFilters[0].title ??
            reduxFilters[0].toolTip ??
            String(reduxFilters[0].id)
          }
          name={reduxFilters[0].id as string}
          id={reduxFilters[0].id as string}
        />{' '}
      </Box>

      <Box>
        <Input
          aria-readonly={reduxFilters[1].readonly}
          readOnly={reduxFilters[1].readonly}
          value={reduxFilters[1].currentValue}
          type="text"
          placeholder={reduxFilters[1].placeholder}
          onChange={(ev) => {
            void store.dispatch(
              listActions.setFilters({
                listId: fieldId,
                filters: [
                  {
                    ...reduxFilters[1],
                    currentValue: ev.target.value,
                  },
                ],
                onlyRedux: true,
              }),
            );
          }}
          onBlur={handleBlur}
          onKeyDown={(ev) => {
            if (ev.key.toLowerCase() === 'enter') {
              handleBlur(ev);
              if (onPressEnter)
                onPressEnter((ev.target as HTMLInputElement).value);
            }
          }}
          onClick={handleClick}
          {...window.getVariant('input')}
          className={`filter ${
            reduxFilters[1].error ? 'requiredFilter__Border' : ''
          }`}
          title={
            reduxFilters[1].title ??
            reduxFilters[1].toolTip ??
            String(reduxFilters[1].id)
          }
          aria-label={
            reduxFilters[1].title ??
            reduxFilters[1].toolTip ??
            String(reduxFilters[1].id)
          }
          name={reduxFilters[1].id as string}
          id={reduxFilters[1].id as string}
        />
      </Box>
    </>
  );
};

export default InputTriple;
